import { render, staticRenderFns } from "./ASLConsent.vue?vue&type=template&id=63ed2c6b&scoped=true"
import script from "./ASLConsent.vue?vue&type=script&lang=js"
export * from "./ASLConsent.vue?vue&type=script&lang=js"
import style0 from "./ASLConsent.vue?vue&type=style&index=0&id=63ed2c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed2c6b",
  null
  
)

export default component.exports